import React from 'react'
import ConnectedComponent from '../../shared/connecter/ConnectedComponent'

//import DelayComponent from '../../layout/components/delay/DelayComponent'

function shuffle(sourceArray) {
    const array = sourceArray.concat()
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array
}

class PlayerComponent extends React.Component {

    static defaultProps = {
        delay: 100
    }

    constructor(props) {
        super(props)
        this.state = {show: true}
    }

    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    render() {

        const style = {display: this.state.show ? 'block' : 'none',  transform: 'translateZ(0)'}
        const imageStyle = {
            backgroundImage: `url(${this.props.player.image})`,
        }
        //bounceInUp

        //image animated bounceIn
        const animations =  shuffle(['bounceInUp', 'rubberBand', 'lightSpeedIn', 'shake', 'swing', 'tada', 'wobble', 'jello', 'jackInTheBox'])

        return (<div style={style} className={'player animated ' + animations[0]}>
            <div className="image-wrapper">
                <div className={'image'} style={imageStyle}/>
            </div>
            <div className="name">
                {this.props.player.name},<br/>
                <span className="text-muted">à toi de jouer !</span>
            </div>
        </div>)
    }


    componentWillUpdate(nextProps, nextState, nextContext) {
        const currentPlayer = this.props.player.id
        const nextPlayer = nextProps.player.id
        if (currentPlayer !== nextPlayer) {
            this.setState({show: false})
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {delay} = this.props

        const currentPlayer = this.props.player.id
        const prevPlayer = prevProps.player.id

        if (currentPlayer !== prevPlayer) {
            this.timeout = setTimeout(() => {
                this.setState({show: true})
                clearTimeout(this.timeout)
            }, delay)
        }

    }
}


function compare(a, b) {
    return b.played - a.played
}

export default class NextPlayerComponent extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('players')
    }

    getCurrentPlayer() {
        return this.store.players.toJSON().map((p, idx) => ({
            ...p,
            played: p.scoreBoard.length + (!idx ? 0 : .5)
        })).sort(compare).reverse()[0]
    }

    render() {
        const player = this.getCurrentPlayer()

        if (this.store.game.get('status') === 'ended' || !player) return (<div/>)

        return (
            <div className="next-player-wrapper">
                <PlayerComponent player={player}/>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/game/players/NextPlayerComponent.jsx